import { assets } from '@yola/ws-sdk';
import React from 'react';
import PropTypes from 'prop-types';
import GalleryImagePreview from './gallery-image-preview';
import GalleryIframePreview from './gallery-iframe-preview';
import mediaTypes from '../constants/media-types';
import isBlob from '../verifiers/is-blob';

const defaultStyle = {};

function getPreviewSource(src, mediaType) {
  if (mediaType === mediaTypes.IFRAME) return src;

  return isBlob(src) ? src : assets.helpers.addBaseHref(src);
}

function GalleryDragItemPreview({
  src,
  width,
  order = null,
  style = defaultStyle,
  isPlaceholder = false,
  placeholderType = null,
  mediaType = mediaTypes.IMAGE,
}) {
  const previewSource = getPreviewSource(src, mediaType);
  const styles = {
    width: `${width}px`,
    height: `${width}px`,
    ...style,
  };
  const currentOrder = order + 1;

  return (
    <div style={styles} className="ws-gallery-item-preview">
      {mediaType === mediaTypes.IFRAME ? (
        <GalleryIframePreview src={previewSource} />
      ) : (
        <GalleryImagePreview
          url={previewSource}
          placeholderType={placeholderType}
          isPlaceholder={isPlaceholder}
        />
      )}
      {currentOrder && (
        <div className="ws-gallery-item__circle-icon ws-gallery-item__order">{currentOrder}</div>
      )}
    </div>
  );
}

GalleryDragItemPreview.propTypes = {
  src: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  order: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.shape(),
  isPlaceholder: PropTypes.bool,
  placeholderType: PropTypes.string,
  mediaType: PropTypes.string,
};

export default GalleryDragItemPreview;
